import * as yup from "yup";

export const CustomizingSchema = yup.object({
  // T0001: yup.string().required("제작 방식을 선택해주세요."),
  // T0002: yup.string().required("사이즈를 모두 입력해주세요."),
  // T0003: yup.string().required("사이즈를 모두 입력해주세요."),
  // T0004: yup.string().required("사이즈를 모두 입력해주세요."),
  // T0005: yup.string().required("사이즈를 모두 입력해주세요."),
  // T0006: yup.string().required("인쇄 여부를 선택해주세요."),
  // //   T0007: yup.string().required("종류를 선택해주세요."),
  // T0008: yup.string().required("색상을 선택해주세요."),
  // T0009: yup.string().required("사이즈를 모두 입력해주세요."),
  // T0011: yup.string().required("사이즈를 모두 입력해주세요."),
  // //   T0012: yup.string().required("골지를 선택해주세요."),
  // T0013: yup.string().required("코팅를 선택해주세요."),
  // T0014: yup.string().required("사이즈를 선택해주세요."),
  // T0015: yup.string().required("박을 선택해주세요."),
  // T0016: yup.string().required("원지 색상을 선택해주세요."),
});
